/* Venocci – cartes d'avis, version française (copie FR de assets/venocci-etsy-reviews.js).
   Utilisé uniquement par sections/venocci-etsy-product-reviews-fr.liquid (mode « product »).
   Le texte est toujours inséré avec textContent (jamais innerHTML). Aucune donnée structurée. */
(function () {
  'use strict';
  var cache = {};
  function getJSON(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  function load(url, partUrls) {
    if (!cache[url]) {
      cache[url] = getJSON(url).then(function (data) {
        if (!data || !Array.isArray(data.parts) || !data.parts.length) return data;
        return Promise.all(data.parts.map(function (name) {
          var u = partUrls && partUrls[name];
          if (!u) throw new Error('Unknown part ' + name);
          return getJSON(u);
        })).then(function (parts) {
          var all = [];
          parts.forEach(function (p) { if (Array.isArray(p && p.reviews)) all = all.concat(p.reviews); });
          data.reviews = all;
          return data;
        });
      });
    }
    return cache[url];
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function fmtDate(iso) {
    var p = String(iso || '').split('-');
    if (p.length !== 3) return iso || '';
    var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
    try { return d.toLocaleDateString('fr-FR', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }); }
    catch (e) { return iso; }
  }
  function stars(rating) {
    var r = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    var s = el('div', 'vetsy-card__stars');
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', 'Note : ' + r + ' sur 5');
    var on = el('span', null, '★'.repeat(r)); on.setAttribute('aria-hidden', 'true');
    var off = el('span', 'vetsy-card__stars-off', '★'.repeat(5 - r)); off.setAttribute('aria-hidden', 'true');
    s.appendChild(on); s.appendChild(off);
    return s;
  }
  function card(rv) {
    var li = el('li', 'vetsy-card');
    var art = el('article', 'vetsy-card__inner');
    art.appendChild(stars(rv.rating));
    var q = el('p', 'vetsy-card__text', rv.text);
    q.setAttribute('lang', 'en');
    art.appendChild(q);
    var meta = el('div', 'vetsy-card__meta');
    meta.appendChild(el('p', 'vetsy-card__name', rv.name));
    var line = el('p', 'vetsy-card__sub');
    var t = el('time', null, fmtDate(rv.date)); t.setAttribute('datetime', rv.date);
    line.appendChild(t);
    meta.appendChild(line);
    art.appendChild(meta);
    li.appendChild(art);
    return li;
  }
  function byDateDesc(a, b) { return String(b.date).localeCompare(String(a.date)) || String(a.id).localeCompare(String(b.id)); }
  function hasText(r) { return typeof r.text === 'string' && r.text.trim().length > 0; }
  function publishable(r) { var n = Number(r && r.rating); return isFinite(n) && n >= 4 && n <= 5 && hasText(r); }

  function init(root) {
    if (root.__vetsyInit) return; root.__vetsyInit = true;
    var url = root.getAttribute('data-src');
    var per = Math.max(1, parseInt(root.getAttribute('data-per-page'), 10) || 6);
    var handle = root.getAttribute('data-product-handle');
    var list = root.querySelector('[data-vetsy-list]');
    var more = root.querySelector('[data-vetsy-more]');
    var status = root.querySelector('[data-vetsy-status]');
    var wrapper = root.closest('.shopify-section') || root;
    var designMode = root.hasAttribute('data-design-mode');
    var partUrls = null;
    try { partUrls = JSON.parse(root.getAttribute('data-part-urls') || 'null'); } catch (e) { partUrls = null; }
    load(url, partUrls).then(function (data) {
      var all = Array.isArray(data && data.reviews) ? data.reviews : [];
      var items = all.filter(function (r) { return r.scope === 'product' && r.product_handle === handle && publishable(r); });
      items.sort(byDateDesc);
      if (!items.length) {
        if (designMode) { status.textContent = 'Aucun avis à afficher pour ce modèle.'; root.hidden = false; }
        else { wrapper.style.display = 'none'; }
        return;
      }
      root.hidden = false;
      var shown = 0;
      function renderMore() {
        var nextItems = items.slice(shown, shown + per);
        var frag = document.createDocumentFragment();
        nextItems.forEach(function (rv) { frag.appendChild(card(rv)); });
        list.appendChild(frag);
        var firstNew = list.children[shown];
        shown += nextItems.length;
        more.hidden = shown >= items.length;
        status.textContent = shown + ' avis affichés sur ' + items.length;
        return firstNew;
      }
      renderMore();
      more.addEventListener('click', function () {
        var first = renderMore();
        if (first) { var f = first.querySelector('.vetsy-card__inner'); if (f) { f.setAttribute('tabindex', '-1'); f.focus({ preventScroll: false }); } }
      });
    }).catch(function () {
      if (designMode) { status.textContent = 'Le fichier des avis n’a pas pu être chargé.'; root.hidden = false; }
      else { wrapper.style.display = 'none'; }
    });
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-vetsy-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
